import React, { useState, useEffect, useRef } from 'react';
import './Slider.css';

const SwipableSlider = ({ slides }) => {
  const [index, setIndex] = useState(0);
  const [startX, setStartX] = useState(null);
  const isUserInteractedRef = useRef(false);
  const intervalIdRef = useRef(null);

  useEffect(() => {
    intervalIdRef.current = setInterval(() => {
      if (!isUserInteractedRef.current) {
        setIndex((prevIndex) => (prevIndex + 1) % slides.length);
      }
    }, 3000);

    return () => clearInterval(intervalIdRef.current);
  }, [slides.length]);

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
    isUserInteractedRef.current = true;
    clearInterval(intervalIdRef.current);
  };

  const handleTouchMove = (e) => {
    if (startX !== null) {
      const currentX = e.touches[0].clientX;
      const diffX = startX - currentX;

      if (diffX > 50) {
        handleNext();
        setStartX(null);
        isUserInteractedRef.current = true;
      } else if (diffX < -50) {
        handlePrev();
        setStartX(null);
        isUserInteractedRef.current = true;
      }
    }
  };

  const handleTouchEnd = () => {
    setStartX(null);
    isUserInteractedRef.current = true; // Set to true to fully disable autoplay
  };

  const handlePrev = () => {
    setIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
    isUserInteractedRef.current = true;
  };

  const handleNext = () => {
    setIndex((prevIndex) => (prevIndex + 1) % slides.length);
    isUserInteractedRef.current = true;
  };

  return (
    <div
      className="swipable-slider"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {slides.map((slide, slideIndex) => (
        <div key={slideIndex} className={`slide ${slideIndex === index ? 'active' : ''}`}>
          <img src={slide.image} alt={`Slide ${slideIndex + 1}`} />
        </div>
      ))}
      <button className="arrow left" onClick={handlePrev}>
        ❰
      </button>
      <button className="arrow right" onClick={handleNext}>
        ❱
      </button>
    </div>
  );
};

export default SwipableSlider;
